import { createAsyncThunk } from "@reduxjs/toolkit";
import { paymentInActions } from "./payment-slice";

// Thunk to reset payment info based on current user
export const resetPaymentInByUser = createAsyncThunk(
  "payment/resetPaymentInByUser",
  (payload, { getState, dispatch }) => {
    const state = getState();
    const userId = state.user.userId; // read the userId from the user slice

    //console.log("userId in store:", getState().user.userId);

    if (userId === 1001) {
      dispatch(paymentInActions.resetPaymentIn({
        ...payload,
          paymentFirma: 
        {
          firstLetter: "L",
          FIRMA_ID : 7,
          FIRMA_NAME : "LUDIS MARKETING CONSULTING LTD",
          FIRMA_AB : "LMC-H",
        },
      }));
    } else {
      dispatch(paymentInActions.resetPaymentIn({
        ...payload,
        paymentFirma: 
        {
          firstLetter: "L",
          FIRMA_ID : 5,
          FIRMA_NAME : "LUDIS MARKETING CONSULTING LTD",
          FIRMA_AB : "LMC-M",
        },
      }));
    }
  }
);
